import { BookOpen, MapPin } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { counties } from "@/data/counties";
import { useScrollAnimation, fadeInUp, AnimatedDiv, AnimatedH2 } from "@/hooks/useScrollAnimation";

const guides = [
  {
    href: "/guides/buying-a-farm-central-valley",
    title: "Buying a Farm in the Central Valley",
    blurb: "Water rights, soil, financing, and the full due-diligence checklist.",
  },
  {
    href: "/guides/almond-vs-pistachio-roi",
    title: "Almonds vs. Pistachios: Which Pays Better?",
    blurb: "Establishment cost, water use, yield timelines, and long-term returns compared.",
  },
  {
    href: "/guides/buying-a-citrus-orchard",
    title: "Buying a Citrus Orchard",
    blurb: "Frost belts, varieties, packinghouse contracts, and HLB quarantine risk.",
  },
];

const Resources = () => {
  const { ref, controls } = useScrollAnimation();

  return (
    <section id="resources" className="py-20 md:py-28 bg-muted">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        <AnimatedDiv ref={ref} initial="hidden" animate={controls} variants={fadeInUp} className="text-center mb-12">
          <p className="text-sm font-medium text-primary tracking-[0.3em] uppercase mb-4">Explore</p>
          <AnimatedH2 variants={fadeInUp} className="text-3xl md:text-5xl heading-luxury text-foreground mb-4">
            Guides &amp; Areas We Serve
          </AnimatedH2>
          <div className="section-divider mt-4"></div>
        </AnimatedDiv>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {guides.map((g) => (
            <a key={g.href} href={g.href} className="block group h-full">
              <Card className="bg-card border-0 shadow-lg h-full hover:shadow-xl transition-all duration-300">
                <CardContent className="p-8">
                  <BookOpen className="h-6 w-6 text-primary mb-4" />
                  <h3 className="text-lg font-semibold text-foreground mb-2 group-hover:text-primary transition-colors">
                    {g.title}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed text-sm">{g.blurb}</p>
                </CardContent>
              </Card>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {counties.map((c) => (
            <a key={c.slug} href={`/farms-for-sale/${c.slug}`} className="block group h-full">
              <Card className="bg-card border-0 shadow-lg h-full hover:shadow-xl transition-all duration-300">
                <CardContent className="p-8">
                  <MapPin className="h-6 w-6 text-primary mb-4" />
                  <h3 className="text-lg font-semibold text-foreground mb-2 group-hover:text-primary transition-colors">
                    Farms for Sale in {c.name}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed text-sm">{c.tagline}</p>
                </CardContent>
              </Card>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Resources;
